
export { NzSelect2Component } from './my-select2.component';
export { MySelectModule } from './myselect.module';
